/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import pipImg from '../../assets/icons/greenDot.svg';
import { doNothing } from '../../language/module';
import { COOL_BLUE } from '../../styles/colors';
import { MediumText, UNSELECTABLE_TEXT } from '../../styles/styles';


const IMG_SIZE_PX = 30;

const OverflowItemPip = (opacity: string) => css`
  width: 10px; 
  height: 10px; 
  margin-right: 5px; 
  ${UNSELECTABLE_TEXT};
  opacity: ${opacity};
  transition: all .5s ease;
`

const styles = {
  cta:       css`
    &:hover {
      background-color: ${COOL_BLUE}; 
      cursor: pointer; 
    }
  `,
  entry:     css`
    display: flex;
    height: 30px;
    flex-basis: 30px;
    flex-shrink: 0;
    flex-direction: row;
    align-items: center;
    padding: 10px 10px 10px 5px;
  `,
  entryText: css`
    ${MediumText};
    ${UNSELECTABLE_TEXT};
  `,
  entryImg:  css`
    width: ${IMG_SIZE_PX}px; 
    height: ${IMG_SIZE_PX}px;
    margin-right: 10px;
    ${UNSELECTABLE_TEXT};
  `,
};


/**
 * OverflowMenuItem: Component for the list items in the GuestCard overflow menu.
 * Encapsulates the styles and basic logic nicely.
 *
 * PureComponent: true
 * Redux Connected: false
 */
export const OverflowMenuItem: React.FC<{
  /**
   * The text of the menu item
   */
  label: string;

  /**
   * The hover text of the menu item
   */
  title: string;
  imgSrc: string;
  showNotificationPip?: boolean;
  disabled?: boolean;
  rootCss?: SerializedStyles;
  onMenuItemClick: () => void;
}> = React.memo(props => (
  <div
    onClick={!props.disabled ? props.onMenuItemClick : doNothing}
    title={props.title}
    css={css`
      ${styles.entry};
      ${!props.disabled && styles.cta};
      opacity: ${props.disabled ? .5 : 1};
      cursor: ${props.disabled ? 'not-allowed' : 'pointer'};
    `}
  >
    <img
      src={pipImg}
      alt='•'
      css={OverflowItemPip(!!props.showNotificationPip ? '1' : '0')}
    />
    <img src={props.imgSrc} alt='img' css={styles.entryImg} />
    <span css={styles.entryText}>{props.label}</span>
  </div>
));
